<div class="header" i18n="@@author-duplicates-warning">ACHTUNG! Es könnten Duplikate vorliegen!</div>
<div class="scrolling content">
  <h3 class="ui header" i18n="@@author-possible-duplicates">Mögliche Duplikate:</h3>
  <app-articles-list
    [articles]="modal.context.possibleDuplicateArticles"
    [showDescription]="false"
    [showAuthor]="true"
    [showUpdatedAt]="true"
    [showLinks]="true"
  ></app-articles-list>
</div>
<div class="actions">
  <button class="ui green button" (click)="modal.approve(undefined)" i18n="@@author-add-anyway">Trotzdem hinzufügen!</button>
  <button class="ui red button" (click)="modal.deny(undefined)" i18n="@@author-dont-add">Nicht hinzufügen!</button>
</div>
